import './informationDocument.css';
import { Article } from "../../services/coworkerApiCalls/Article/ArticlesTypes";
import { ArticleFull } from "../article/article";
import { useDataApiArticleByCategoryBySpace} from "../../Hooks/useDataArticlesApi";
/**
 * @function InformationDocumentation displays a googledocs of the Coworking information from the company google drive  
 * @returns {JSX.Element} HTML element
 */
function InformationDocumentation(){
  const article: Article = useDataApiArticleByCategoryBySpace(3)!;
  
  return(
    <>
    {/* the space for the check and sign button is reserved if the user hasn't sign the charter yet*/}
    <ArticleFull {...article} />
  </>
  );
}

export {InformationDocumentation};